/* eslint-disable @typescript-eslint/no-loss-of-precision */
import * as React from 'react';
import { Numberbox } from 'ui';
import { ScreenFieldProps, ScreenField } from 'app/area/codetable/item/screen-renderer/types';
import { ReadOnlyType } from 'app/area/codetable/item/types';

export const ScoreCalcWeight = ({ codeItem, updateByKey, resetValidation, readOnlyConfig, translation, validation }: ScreenFieldProps) => {

  const onChange = (value: number) => {
    resetValidation(ScreenField.scoreCalcWeight);
    updateByKey(ScreenField.scoreCalcWeight, value);
  };

  const scoreCalcWeightValidation = !!validation && !!validation.scoreCalcWeight ? validation.scoreCalcWeight : undefined;

  return <div className="col-lg-6 col-sm-12">
    <Numberbox
      componentId={ScreenField.scoreCalcWeight}
      readOnly={readOnlyConfig && readOnlyConfig[ReadOnlyType.all]}
      label={{ text: translation.score_calc_weight }}
      value={codeItem && codeItem.scoreCalcWeight}
      validation={scoreCalcWeightValidation}
      onChange={onChange}
      useThousand=" "
      minValue={-9999999999999999.99}
      textInvalidRangeError={translation.must_be_within_range}
      maxValue={99999999999999}
      maxDecimals={2}
    />
  </div>;
};
